import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import { useAuth } from "AuthContext";

function AdminDashboard() {
  const { token } = useAuth();
  const [stats, setStats] = useState({
    onlineCount: 0,
    totalUsers: 0,
    totalStrategies: 0,
    pendingAudits: 0,
    recentRentals: [],
  });

  useEffect(() => {
    fetch("/api/admin/dashboard", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        // Only update stats if we got a valid object (not a 403 error message)
        if (data && typeof data === "object" && !data.message) {
          setStats(data);
        } else {
          console.error("❌ Admin dashboard 無權限或錯誤:", data?.message);
        }
      })
      .catch((err) => console.error("Fetch dashboard error:", err));
  }, [token]);

  // 轉換最近租賃數據為圖表格式 (簡單示例)
  const chartData = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    datasets: { label: "Revenue", data: [0, 0, 0, 0, 0, 0, 0] },
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDTypography variant="h4" mb={2}>系統概況儀表板</MDTypography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                icon="people"
                title="目前在線人數"
                count={stats.onlineCount}
                percentage={{ color: "success", amount: "", label: "實時活動 (10min)" }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="person_add"
                title="總註冊用戶"
                count={stats.totalUsers}
                percentage={{ color: "success", amount: "", label: "累計用戶" }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="assignment"
                title="總策略數量"
                count={stats.totalStrategies}
                percentage={{ color: "success", amount: "", label: "系統總計" }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon="pending_actions"
                title="待處理審核"
                count={stats.pendingAudits}
                percentage={{ color: "success", amount: "", label: "需要查閱" }}
              />
            </MDBox>
          </Grid>
        </Grid>
        
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="租賃營收趨勢"
                  description="過去 7 天的平台總收入金額"
                  date="剛剛更新"
                  chart={chartData}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default AdminDashboard;
